import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, umsUrl } from '../../../../Containers/Config/index.js';
import { V2_CLIENT_FORGOT_PASSWORD, V2_CLIENT_FORGOT_PASSWORD_SUCCESS, V2_CLIENT_FORGOT_PASSWORD_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* v2ClientForgotPassword({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/client/forgot-password`,
      method: 'POST',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        'Project-Code': 'ADMIN_ACCESS',
        'X-Requested-By': 'one-admin',
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: V2_CLIENT_FORGOT_PASSWORD_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: V2_CLIENT_FORGOT_PASSWORD_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: V2_CLIENT_FORGOT_PASSWORD_ERROR, payload: error });
  }
}

export function* watchV2ClientForgotPassword() {
  yield takeEvery(V2_CLIENT_FORGOT_PASSWORD, v2ClientForgotPassword);
}

function* v2ClientForgotPasswordSaga() {
  yield all([fork(watchV2ClientForgotPassword)]);
}

export default v2ClientForgotPasswordSaga;
